import { render } from "./uploadTemplate.vue?vue&type=template&id=90e03230&scoped=true"
import script from "./uploadTemplate.vue?vue&type=script&lang=js"
export * from "./uploadTemplate.vue?vue&type=script&lang=js"

import "./uploadTemplate.vue?vue&type=style&index=0&id=90e03230&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90e03230"]])

export default __exports__